import { Component, ViewEncapsulation, OnInit } from "@angular/core";
import {
  ReactiveFormsModule,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { CraneListService } from "../../services/craneListService";
import { Router } from "@angular/router";
import { AppStateService } from "../../services/appState.service";
import { Subscription } from "rxjs";
import { KranSetupAllgemeinComponent } from "./kranSetupAllgemein.component";
import * as allgemeineFunktionen from "../../allgemeinesTS_CSS/allgemeineHilfsfunktionen";

@Component({
  selector: "app-crane-setup",
  templateUrl: "./tabellen360GradSetup.component.html",
  styleUrls: [
    "./kranSetupAllgemein.component.css",
    "../craneSetup/egrid.css",
    "../../allgemeinesTS_CSS/tooltip.css",
    "../../allgemeinesTS_CSS/cssButton.css",
  ],
  providers: [CraneListService],
  encapsulation: ViewEncapsulation.None,
})
export class Tabellen360GradSetupComponent
  extends KranSetupAllgemeinComponent
  implements OnInit
{
  // private SetupForm: FormGroup;
  public haWinkel: string[] = [];
  public gesetzterHAWinkel = "";
  public hi1Laengen: string[] = [];
  public gesetzteHI1Laenge = "";
  public hi1Winkel: string[] = [];
  public gesetzterHI1Winkel = "";
  constructor(
    private fb: FormBuilder,
    private craneListService: CraneListService,
    private router: Router,
    private appStateService: AppStateService
  ) {
    super(fb, craneListService, router, appStateService);
  }

  ngOnInit() {
    this.tabellenEinstellungen["selectionMode"] = { selectionMode: ["row"] };
    this.tabellenEinstellungen["pageSettings"] = { pageSize: 10 };
    this.appStateService.appStatusVonServerHolen().then((res) => {
      if (res["loginStatus"] !== "loggedIn") {
        this.router.navigate(["/"]);
      }
      this.appStateService.appStatusSetzen({
        aktuellerMenuePunkt: "CraneSetup",
        PrintOut: "inactive",
      });
      this.gewichtsEinheit = this.appStateService.holeEinheitenSystem("G");
      this.laengenEinheit = this.appStateService.holeEinheitenSystem("L");
      if (this.appStateService.aktuellerAppStatus["einheitenSystem"] === "M") {
        this.stellenNachEinheitenSystem = 2;
      } else {
        this.stellenNachEinheitenSystem = 1;
      }
      if (this.appStateService.aktuellerAppStatus["kranname"] !== undefined) {
        this.kranname = this.appStateService.aktuellerAppStatus["kranname"];
      }
      // Tabelle laden
      this.ladeKran = true;
      if (
        this.kranKennung["kranDatenbankNamen"] === undefined &&
        (this.appStateService.aktuellerAppStatus["kranDatenbankNamen"] ===
          undefined ||
          this.appStateService.aktuellerAppStatus["kranDatenbankNamen"] === "")
      ) {
        this.zeigeFehler("No crane selected", "Please chosse a crane.", () => {
          this.router.navigate(["/craneSelection"]);
        });
        return;
      } else {
        this.kranKennung["kranDatenbankNamen"] =
          this.appStateService.aktuellerAppStatus["kranDatenbankNamen"];
      }
      // erzeuge Datenbank auf dem Server und hole Daten für das Formular
      this.ladeRuestzustand = true;
      this.RHLRadius =
        this.appStateService.aktuellerAppStatus["RHLRadius"] === undefined ||
        this.appStateService.aktuellerAppStatus["RHLRadius"] === "null"
          ? ""
          : this.appStateService.aktuellerAppStatus["RHLRadius"];
      this.SetupForm.get("Radius").setValue(this.RHLRadius);
      this.RHLLast =
        this.appStateService.aktuellerAppStatus["RHLLast"] === undefined ||
        this.appStateService.aktuellerAppStatus["RHLLast"] === "null"
          ? ""
          : this.appStateService.aktuellerAppStatus["RHLLast"];
      this.SetupForm.get("Last").setValue(this.RHLLast);
      this.RHLHoehe =
        this.appStateService.aktuellerAppStatus["RHLHoehe"] === undefined ||
        this.appStateService.aktuellerAppStatus["RHLHoehe"] === "null"
          ? ""
          : this.appStateService.aktuellerAppStatus["RHLHoehe"];
      this.SetupForm.get("Hoehe").setValue(this.RHLHoehe);
      this.craneListService.holeRuestdaten().then((res1) => {
        this.einlesenRuestdaten(res1);
        this.craneListService
          .getPartsSelectionData(
            this.kranKennung["kranDatenbankNamen"],
            "",
            this.RHLRadius,
            this.RHLLast,
            this.RHLHoehe,
            this.ruestFilter
          )
          .then((res2) => {
            this.ladeRuestzustaende(res2);
            this.craneListService
              .getKranTabelle(this.kranKennung["kranDatenbankNamen"])
              .then((res3) => {
                this.ladeTabelle(res3);
              });
          });
      });
    });

    // erzeuge das Setupformular
    this.SetupForm = this.fb.group({
      Radius: [this.RHLRadius],
      Last: [this.RHLLast],
      Hoehe: [this.RHLHoehe],
      Kombination: [this.gesetzteKombination],
      Identnr: [this.gesetzteIdentnr],
      Gegengew: [this.gesetztesGegengew],
      AbstuetzW: [this.gesetzteAbstuetzung],
      HALaenge: [this.gesetzteHALaenge],
      HAWinkel: [this.gesetzterHAWinkel],
      HAAusfahrf: [this.gesetzteHAAusfahrf],
      HI1Laenge: [this.gesetzteHI1Laenge],
      HI1Winkel: [this.gesetzterHI1Winkel],
    });
  }
  einlesenRuestdaten(res) {
    super.einlesenRuestdaten(res);
    if (res["Kombination"] !== undefined) {
      this.gesetzteKombination = res["Kombination"];
      this.KranFilterTabelle.widget.filterColumn(
        "Kombination",
        "equal",
        this.gesetzteKombination,
        "and",
        true
      );
    } else {
      this.gesetzteKombination = res["Kombination"] = "";
      this.KranFilterTabelle.widget.clearFiltering("Kombination");
    }
    this.SetupForm.get("Kombination").setValue(this.gesetzteKombination);
    if (res["Abstuetzung"] !== undefined && res["Abstuetzung"] !== "") {
      this.gesetzteAbstuetzung = res["Abstuetzung"];
      this.KranFilterTabelle.widget.filterColumn(
        "AbstuetzW",
        "equal",
        this.gesetzteAbstuetzung,
        "and",
        true
      );
    } else {
      this.gesetzteAbstuetzung = res["Abstuetzung"] = "";
      this.KranFilterTabelle.widget.clearFiltering("AbstuetzW");
    }
    this.SetupForm.get("AbstuetzW").setValue(this.gesetzteAbstuetzung);
    if (res["HAWinkel"] !== undefined) {
      this.gesetzterHAWinkel = res["HAWinkel"];
      //      this.KranFilterTabelle.widget.filterColumn('HAWinkel', 'equal', this.gesetzterHAWinkel, 'and', true);
      this.KranFilterTabelle.widget.clearFiltering("HAWinkel");
      // Filter kann erst verlaesslich gesetzt werden, wenn auch die moeglichen Ruestdaten vorhanden sind.
    } else {
      this.gesetzterHAWinkel = res["HAWinkel"] = "";
      this.KranFilterTabelle.widget.clearFiltering("HAWinkel");
    }
    this.SetupForm.get("HAWinkel").setValue(this.gesetzterHAWinkel);
    if (res["HILaenge"] !== undefined) {
      this.gesetzteHI1Laenge = res["HILaenge"];
      this.KranFilterTabelle.widget.filterColumn(
        "HILaenge",
        "equal",
        this.gesetzteHI1Laenge,
        "and",
        true
      );
    } else {
      this.gesetzteHI1Laenge = res["HILaenge"] = "";
      this.KranFilterTabelle.widget.clearFiltering("HILaenge");
    }
    this.SetupForm.get("HI1Laenge").setValue(this.gesetzteHI1Laenge);
    if (res["HIWinkel"] !== undefined) {
      this.gesetzterHI1Winkel = res["HIWinkel"];
      this.KranFilterTabelle.widget.filterColumn(
        "HIWinkel",
        "equal",
        this.gesetzterHI1Winkel,
        "and",
        true
      );
    } else {
      this.gesetzterHI1Winkel = res["HIWinkel"] = "";
      this.KranFilterTabelle.widget.clearFiltering("HIWinkel");
    }
    this.SetupForm.get("HI1Winkel").setValue(this.gesetzterHI1Winkel);
    if (res["Identnr"] !== undefined) {
      this.SetupForm.get("Identnr").setValue(this.gesetzteIdentnr);
    } else {
      this.SetupForm.get("Identnr").setValue("");
    }
  }
  ladeRuestzustaende(kranDaten) {
    // this.appStateService.kranGewaehltNeu(this.kranKennung);
    super.ladeRuestzustaende(kranDaten);
    if (this.identnummern.length === 2) {
      this.SetupForm.get("Identnr").setValue(this.identnummern[1]);
    }
    // Falls Abstuetzung gesetzt enthält die Liste nur die Reset- Möglichkeit ('') und den gesetzten Wert.
    if (this.gesetzteAbstuetzung !== "" && this.gesetzteAbstuetzung != null) {
      this.abstuetzungen = ["", this.gesetzteAbstuetzung];
    } else {
      Array.prototype.push.apply(
        this.abstuetzungen,
        kranDaten["Abstuetzungen"]
      );
    }
    this.haWinkel = [""];
    this.hi1Laengen = [""];
    this.hi1Winkel = [""];
    Array.prototype.push.apply(this.haWinkel, kranDaten["HAWinkel"]);
    Array.prototype.push.apply(this.hi1Laengen, kranDaten["HI1Laengen"]);
    Array.prototype.push.apply(this.hi1Winkel, kranDaten["HI1Winkel"]);
    // Filter fuer HAWinkel setzen
    if (this.haWinkel.some((x) => +x === +this.gesetzterHAWinkel)) {
      this.KranFilterTabelle.widget.filterColumn(
        "HAWinkel",
        "equal",
        this.gesetzterHAWinkel,
        "and",
        true
      );
    } else {
      this.gesetzterHAWinkel = "";
      this.KranFilterTabelle.widget.clearFiltering("HAWinkel");
    }
    this.SetupForm.get("HAWinkel").setValue(this.gesetzterHAWinkel);
  }
  ruestzustandAendern(event: any) {
    super.ruestzustandAendern(event);
    const zuAendernderRuestzustand = event.target.id;
    const neuerWert = event.target.value;
    switch (zuAendernderRuestzustand) {
      case "HAWinkel":
        this.gesetzterHAWinkel = neuerWert;
        this.SetupForm.get("HAWinkel").setValue(this.gesetzterHAWinkel);
        break;
      case "HI1Laenge":
        this.gesetzteHI1Laenge = neuerWert;
        this.SetupForm.get("HI1Laenge").setValue(this.gesetzteHI1Laenge);
        break;
      case "HI1Winkel":
        this.gesetzterHI1Winkel = neuerWert;
        this.SetupForm.get("HI1Winkel").setValue(neuerWert);
        break;
      case "Identnr":
        this.SetupForm.get("Identnr").setValue(this.gesetzteIdentnr);
        break;
      case "Gegengew":
        this.SetupForm.get("Gegengew").setValue(this.gesetztesGegengew);
        break;
      default:
        break;
    }
    this.holeKranRuestzustaende(
      this.gesetzteIdentnr,
      this.gesetztesGegengew,
      this.gesetzteHALaenge,
      this.gesetzteAbstuetzung,
      this.gesetzteHAAusfahrf,
      "",
      "",
      this.gesetzteKombination,
      this.gesetzterHAWinkel,
      this.gesetzteHI1Laenge,
      this.gesetzterHI1Winkel
    ).then(() => {
      this.setzeHALaengeAusfahrf(zuAendernderRuestzustand);
    });
  }
  resetFilter(art = "alles") {
    this.gesetzteKombination = "";
    this.SetupForm.get("Kombination").setValue("");
    this.gesetzterHAWinkel = "";
    this.SetupForm.get("HAWinkel").setValue("");
    this.gesetzteHI1Laenge = "";
    this.SetupForm.get("HI1Laenge").setValue("");
    this.gesetzterHI1Winkel = "";
    this.SetupForm.get("HI1Winkel").setValue("");
    this.gesetzteIdentnr = "";
    this.SetupForm.get("Identnr").setValue("");
    this.gesetztesGegengew = "";
    this.SetupForm.get("Gegengew").setValue("");
    this.gesetzteAbstuetzung = "";
    this.SetupForm.get("AbstuetzW").setValue("");
    super.resetFilter(art);
    return true;
  }
  go360TableControl() {
    this.router.navigate(["/control360Table"]);
  }
  // sucheKkran muss nun hier auch noch mal kommen, da wir ab Angular7 ngModel  nich tmehr mit ReactiveForms nutzen kann
  sucheKran() {
    this.RHLRadius = this.SetupForm.get("Radius").value;
    this.RHLLast = this.SetupForm.get("Last").value;
    this.RHLHoehe = this.SetupForm.get("Hoehe").value;
    super.sucheKran();
  }
}
